import React from "react"
import {
    Box,
    Card,
    CardContent,
    TextField,
    Typography,
    Button,
    Divider,
    Stack,
} from "@mui/material"
import _ from "lodash"
import { useCreateBonofideCertificateMutation } from "../Redux/actions/certificate.action"
import {
    updateFields,
    resetForm
} from "../Redux/actions/formValue.action"
import { useDispatch, useSelector } from "react-redux"
import { Loader } from "../components/index"
import { toaster, Message } from "rsuite"

const BonofideCertificateForm = () => {
    const dispatch = useDispatch()

    const [generateBonofide, generateBonofideState] = useCreateBonofideCertificateMutation()

    const state = useSelector((state) => state.form)

    React.useEffect(() => {
        if (generateBonofideState.isSuccess) {
            const blob = generateBonofideState.data

            const url = window.URL.createObjectURL(blob)

            const a = document.createElement("a")
            a.href = url
            a.download = "bonafide_certificate.pdf"
            document.body.appendChild(a)
            a.click()

            a.remove()
            window.URL.revokeObjectURL(url)
            generateBonofideState.reset()
            dispatch(resetForm())
        }else if(generateBonofideState.isError){
            toaster.push(<Message type="error" >Error while create the bonofide certificate,Please try again later!</Message>,{placement:"topCenter"})
            generateBonofideState.reset()
        }
    }, [generateBonofideState.status])


    const handleSubmit = () => {
        const academic_year = _.get(state, "state.academic_year", "")
        const authority = _.get(state, "state.authority", "")
        const course = _.get(state, "state.course", "")
        const date = _.get(state, "state.date", "")
        const institution_address = _.get(state, "state.institution_address", "")
        const institution_name = _.get(state, "state.institution_name", "")
        const name = _.get(state, "state.name", "")
        const parent_name = _.get(state, "state.parent_name", "")
        const roll_number = _.get(state, "state.roll_number", "")
        const year = _.get(state, "state.year", "")

        if (
            !academic_year ||
            !authority ||
            !course ||
            !date ||
            !institution_address ||
            !institution_name ||
            !name ||
            !parent_name ||
            !roll_number ||
            !year
        ) {
            toaster.push(<Message type="info" >Please provide all fields details</Message>, { placement: "topCenter" })
            return
        }
        const data = {
            academic_year:academic_year,
            authority:authority,
            course:course,
            date:date,
            institution_address:institution_address,
            institution_name:institution_name,
            student_name:name,
            parent_name:parent_name,
            roll_number:roll_number,
            year:year
        }
        generateBonofide(data)
    }

    return (
        <Box sx={{ maxWidth: 700, mx: "auto", mt: 5 }}>
            <Card
                elevation={3}
                sx={{
                    borderRadius: 3,
                    px: 1,
                }}
            >
                <CardContent>
                    <Typography variant="h5" fontWeight={600}>
                        Certificate Details
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={2}>
                        Fill all the required student and institution details
                    </Typography>

                    <Divider sx={{ mb: 3 }} />

                    <Stack spacing={2.5}>
                        <TextField
                            label="Date"
                            name="date"
                            placeholder="DD-MM-YYYY"
                            fullWidth
                            value={_.get(state, "state.date", "")}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ date: val }))
                            }}
                            type="date"
                            focused
                        />

                        <TextField
                            label="Student Name"
                            name="student_name"
                            fullWidth
                            value={_.get(state, "state.name", "")}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ name: val }))
                            }}
                        />

                        <TextField
                            label="Parent / Guardian Name"
                            name="parent_name"
                            fullWidth
                            value={_.get(state, "state.parent_name", "")}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ parent_name: val }))
                            }}
                        />

                        <TextField
                            label="Roll Number"
                            name="roll_number"
                            fullWidth
                            value={_.get(state, "state.roll_number", "")}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ roll_number: val }))
                            }}
                        />

                        <TextField
                            label="Year / Semester / Class"
                            name="year"
                            placeholder="Second / Final"
                            fullWidth
                            value={_.get(state, "state.year", "")}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ year: val }))
                            }}
                        />

                        <TextField
                            label="Course"
                            name="course"
                            fullWidth
                            value={_.get(state, "state.course", "")}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ course: val }))
                            }}
                        />

                        <TextField
                            label="Academic Year"
                            name="academic_year"
                            placeholder="2024 – 2025"
                            fullWidth
                            value={_.get(state, "state.academic_year", "")}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ academic_year: val }))
                            }}
                        />

                        <TextField
                            label="Institution Name"
                            name="institution_name"
                            fullWidth
                            value={_.get(state, "state.institution_name", "")}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ institution_name: val }))
                            }}
                        />

                        <TextField
                            label="Institution Address"
                            name="institution_address"
                            multiline
                            rows={2}
                            fullWidth
                            value={_.get(state, "state.institution_address", "")}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ institution_address: val }))
                            }}
                        />

                        <TextField
                            label="Issuing Authority"
                            name="authority"
                            placeholder="Principal / Dean"
                            fullWidth
                            value={_.get(state, "state.authority", "")}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ authority: val }))
                            }}
                        />
                    </Stack>

                    <Box sx={{ mt: 4, textAlign: "right" }}>
                        <Button
                            variant="contained"
                            size="large"
                            sx={{ px: 4 }}
                            onClick={handleSubmit}
                        >
                            Generate Certificate
                        </Button>
                    </Box>
                </CardContent>
            </Card>
            {
                (
                    generateBonofideState.isLoading
                ) && (
                    <Loader show={true} />
                )
            }
        </Box>
    )
}

export default BonofideCertificateForm
